var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgInfo = function SvgInfo(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Info' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,46 C11.869,46 2,36.131 2,24 C2,11.869 11.869,2 24,2 C36.131,2 46,11.869 46,24 C46,36.131 36.131,46 24,46 M24,0 C10.767,0 0,10.767 0,24 C0,37.233 10.767,48 24,48 C37.233,48 48,37.233 48,24 C48,10.767 37.233,0 24,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16 C25.105,16 26,15.104 26,14 C26,12.896 25.105,12 24,12 C22.895,12 22,12.896 22,14 C22,15.104 22.895,16 24,16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.4962 20.0093 20.4962 20.0093 20.4962 22.0093 23.4962 22.0093 23.4962 34.0093 20.4962 34.0093 20.4962 36.0093 28.4962 36.0093 28.4962 34.0093 25.4962 34.0093"
  }));
};
SvgInfo = pure(SvgInfo);
SvgInfo.displayName = 'SvgInfo';
export default SvgInfo;